module.exports = __webpack_public_path__ + "media/music/saw_lead_4-83251eab.mp3";